// extracted by mini-css-extract-plugin
module.exports = {"textareawrapper":"TableData_textareawrapper___XkbV","button":"TableData_button__2A_WS"};